import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { InputGroup, InputGroupText, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import
{
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import
{
  getCodePromos as onGetCodePromos,
  addNewCodePromo as onAddNewCodePromo,
  updateCodePromo as onUpdateCodePromo,
} from "../../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";
import { lireRoleSession } from "../../../espace";
const CodePromo = ( props ) =>
{
  const [ loading, setLoading ] = useState( true );

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric"
    } );
    return dateObject;
  }

  const history = useHistory();
  const [ formData1, setFormData1 ] = useState( {} );
  const dispatch = useDispatch();
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).accessToken
    : null;

  // const { codePromos, isCodePromoCreated, isCodePromoSuccess, error } =
  //   useSelector( ( state ) => ( {
  //     codePromos: state.CodePromo.codePromos,
  //     isCodePromoCreated: state.CodePromo.isCodePromoCreated,
  //     isCodePromoSuccess: state.CodePromo.isCodePromoSuccess,
  //     error: state.CodePromo.error,
  //   } ) );

  const [ reducerValue, forceUpdate ] = useReducer( ( x ) => x + 1, 0 );

  function handleClick ()
  {
    forceUpdate();
  }

  const [ codePromos, setCodePromos ] = useState( [] )
  const fetchCodePromo = async () =>
  {
    try
    {
      const code_promo = await axiosInstance.get( `/getallcodepromo/` );
      //   console.log("code_promo: ", code_promo);
      if ( code_promo?.data )
      {
        setCodePromos( code_promo.data.data );
      }
    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };

  // Après une suspension ou une suppression, l'écran rappelait toujours la
  // liste administrateur : pour un organisateur, c'était un 403 avalé par le
  // catch, et sa liste se vidait sous ses yeux. Un seul point d'entrée, qui
  // choisit la bonne route.
  const rafraichirListe = () =>
    roleSession === "ORGANISATEUR" ? fetchCodeReduction() : fetchCodePromo();

  const fetchCodeReduction = async () =>
  {
    try
    {
      // `/codereductionevent/` exige un `event_id` et répondait 400 sans lui.
      // `/codepromofororga/` liste tous les codes des événements du
      // gestionnaire, ce que cet écran veut afficher.
      const code_reduction = await axiosInstance.get( `/codepromofororga/` );
      // console.log("code_reduction: ", code_reduction);
      if ( code_reduction?.data )
      {
        setCodePromos( code_reduction.data.data );
      }
    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };


  const [ modalConfirmDelete, setModalConfirmDelete ] = useState( false );
  const [ codePromoGenerate, setCodePromoGenerate ] = useState( "" );
  const [ isEdit, setIsEdit ] = useState( false );
  const [ isExportCSV, setIsExportCSV ] = useState( false );
  const [ codePromoSelected, setCodePromoSelected ] = useState( {} );

  //delete Conatct
  const [ modal, setModal ] = useState( false );


  // const toggle = useCallback(() => {
  //   if (modal) {
  //     setModal(false);
  //     setCodePromoSelected(null);
  //   } else {
  //     setModal(true);
  //   }
  //   generatePromoCode();
  // }, [modal]);

  // Add Data
  const handleCodePromoClicks = () =>
  {
    setCodePromoSelected( "" );
    setIsEdit( false );
    // toggle();
  };

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )

  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )
      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }

  useEffect( () =>
  {
    getSessionData()
  }, [] )


  useEffect( () =>
  {
    if ( roleSession === "ORGANISATEUR" )
    {
      fetchCodeReduction();
    } else
    {
      fetchCodePromo();
    }
  }, [ roleSession ] );

  // Update Data
  const handleCodePromoClick = useCallback( ( arg ) =>
  {
    const codePromo = arg;
    // console.log( "codePromo arg: ", codePromo )
    setCodePromoSelected( {
      id: codePromo.id,
      code_promo: codePromo.code_promo,
      user_id: codePromo.user_id,
      type_reduction: codePromo.type_reduction,
      pourcentage: codePromo.pourcentage,
      delais: codePromo.delais,
      nbr_max: codePromo.nbr_max,
      statut: codePromo.statut,
    } );

    // toggle();
  }, [] );

  function generatePromoCode ()
  {
    let code = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for ( let i = 0; i < 5; i++ )
    {
      const randomIndex = Math.floor( Math.random() * characters.length );
      code += characters[ randomIndex ];
    }
    setCodePromoGenerate( code );
  }

  const handleActiveCode = useCallback( ( status, idCodePromo ) =>
  {
    axiosInstance
      .put( `/statutcodePromo/?id=${ idCodePromo }`, {
        statut: status,
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Code Promo suspendu avec succès" );
        // dispatch( onGetCodePromos() );
        rafraichirListe();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de l'activation du code Promo" );
      } );
  }, [] );

  const handleDelete = () =>
  {
    axiosInstance
      .delete( `/deletecodepromo/?id=${ codePromoSelected.id }` )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Code Promo supprimé avec succès" );
        // dispatch( onGetCodePromos() );
        rafraichirListe();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de la supression du code promo" );
      } );

    setModalConfirmDelete( false );

    setCodePromoSelected( null );
  };

  // Column
  const columns = useMemo(
    () =>
      roleSession !== "ORGANISATEUR" ?
        [
          // {
          //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
          //   Cell: ( cellProps ) =>
          //   {
          //     return <input type="checkbox" name="id" className="codePromoCheckBox" value={ cellProps.row.original.id } />;
          //   },
          //   id: '#',
          // },

          {
            Header: props.t( "Code Promo" ),
            accessor: "code_promo",
            filterable: false,
            Cell: ( cell ) => (
              <>
                <span style={ { color: "#014c94" } }>
                  { cell.row.original.code_promo }
                </span>
              </>
            ),
          },
          {
            Header: props.t( "Créateur" ),
            accessor: "last_name",
            filterable: false,
            Cell: ( createur ) => (
              <>
                { createur.row.original.last_name } { createur.row.original.first_name }
              </>
            ),
          },
          {
            Header: props.t( "Maximum" ),
            accessor: "nbr_max",
            filterable: false,
          },
          {
            Header: props.t( "Pourcentage" ),
            accessor: "pourcentage",
            filterable: false,
            Cell: ( cell ) => (
              <>
                { cell.row.original.pourcentage } { " %" }
              </>
            ),
          },
          {
            Header: props.t( "Type de réduction" ),
            accessor: "type_reduction",
            filterable: true,
          },
          {
            Header: props.t( "Délai" ),
            accessor: "delais",
            filterable: false,
            Cell: ( delai ) => (
              <>
                { delai.row.original.delais } { " jour(s)" }
              </>
            ),
          },
          {
            Header: props.t( "Expiration" ),
            accessor: "date_expiration",
            filterable: false,
            Cell: ( delai ) =>
            {
              if ( delai.row.original.date_expiration )
              {
                return moment( new Date( delai.row.original.date_expiration ), "D/MM/YY" ).format( "DD MMM Y à HH:mm:ss" )
              } else
              {
                return (
                  <span>
                    Date invalide
                  </span>
                )
              }
            },
          },
          {
            Header: props.t( "Dernière modification" ),
            accessor: "updated_at",
            filterable: false,
            Cell: ( delai ) => formatDate( delai.row.original.updated_at ),
          },
          {
            Header: props.t( "Statut" ),
            accessor: "statut",
            filterable: true,
            Cell: ( cell ) => (
              <>
                { cell.row.original.statut ? (
                  <span className="badge badge-soft-success me-1">Activé</span>
                ) : (
                  <span className="badge badge-soft-danger me-1">Suspendu</span>
                ) }
              </>
            ),
          },
          {
            Header: props.t( "Action" ),
            Cell: ( cellProps ) =>
            {
              const codePromoData = cellProps.row.original;
              return (
                <ul className="list-inline hstack gap-2 mb-0">
                  {/* <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/codePromoDetail/${codePromoData.id}`}
                  className="text-success d-inline-block"
                  onClick={() => {
                    const codePromoData = cellProps.row.original;
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li> */}
                  <li className="list-inline-item" title={ props.t( "Modifier" ) }>
                    <Link
                      to="#"
                      className="text-warning d-inline-block"
                      onClick={ () =>
                      {
                        const codePromoData = cellProps.row.original;
                        // console.log( "codePromoData: ", cellProps.row.original );
                        handleCodePromoClick( codePromoData );
                        setIsEdit( true );
                        setModal( true );
                        // toggle();
                      } }
                    >
                      <i className="ri-pencil-fill align-bottom"></i>
                    </Link>
                  </li>
                  {/* <li className="list-inline-item" title={props.t("Détails")}>
                <Link
                  to={`/code-promo/${cellProps.row.original.id && cellProps.row.original.id}`}
                  className="btn btn-sm btn-success d-inline-block"
                  // onClick={() => {
                  //   const parainageData = cellProps.row.original;
                  // }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li> */}
                  { codePromoData.statut ? (
                    <>
                      <li className="list-inline-item" title={ props.t( "Suspendre" ) }>
                        <Link
                          to="#"
                          className="btn btn-sm btn-danger d-inline-block"
                          onClick={ ( e ) =>
                          {
                            e.preventDefault();
                            const codePromoDataId = cellProps.row.original.id;
                            // console.log( "codePromoData: ", cellProps.row.original );
                            handleActiveCode( false, codePromoDataId );
                          } }
                        >
                          <i className="ri-close-line align-bottom"></i>
                          {/* Suspendre */ }
                        </Link>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="list-inline-item" title={ props.t( "Activer" ) }>
                        <Link
                          to="#"
                          className="btn btn-sm btn-success d-inline-block"
                          onClick={ ( e ) =>
                          {
                            e.preventDefault();
                            const codePromoDataId = cellProps.row.original.id;
                            // console.log( "codePromoData: ", cellProps.row.original );
                            handleActiveCode( true, codePromoDataId );
                          } }
                        >
                          <i className="ri-check-line align-bottom"></i>
                          {/* Activer */ }
                        </Link>
                      </li>
                    </>
                  ) }
                  <li className="list-inline-item" title={ props.t( "Activer" ) }>
                    <Link
                      to="#"
                      className="btn btn-sm btn-outline-danger d-inline-block"
                      onClick={ ( e ) =>
                      {
                        e.preventDefault();
                        const codePromoData = cellProps.row.original;
                        // console.log( "codePromoData: ", codePromoData );
                        handleCodePromoClick( codePromoData );
                        // handleDelete(codePromoDataId);
                        setModalConfirmDelete( true );
                      } }
                    >
                      <i className=" bx bx-trash align-middle"></i>
                      {/* Supprimer */ }
                    </Link>
                  </li>
                </ul>
              );
            },
          },
        ] :

        [
          // {
          //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
          //   Cell: ( cellProps ) =>
          //   {
          //     return <input type="checkbox" name="id" className="codePromoCheckBox" value={ cellProps.row.original.id } />;
          //   },
          //   id: '#',
          // },

          {
            Header: props.t( "Code de réduction" ),
            accessor: "code",
            filterable: false,
            // Cell: ( cell ) => (
            //   <>
            //     <span style={ { color: "#014c94" } }>
            //       { cell.row.original.code }
            //     </span>
            //   </>
            // ),
          },
          {
            Header: props.t( "Pourcentage" ),
            accessor: "pourcentage",
            filterable: false,
            Cell: ( cell ) => (
              <>
                { cell.row.original.pourcentage } { " %" }
              </>
            ),
          },
          {
            Header: props.t( "Evénement" ),
            accessor: "event_id",
            filterable: true,
          },
          {
            Header: props.t( "Billet" ),
            accessor: "billet_id",
            filterable: true,
          },
         
        ],
    [ roleSession, handleActiveCode, handleCodePromoClick, props ]
    // [setInfo, handleCodePromoClick, toggle, props, handlerefuse, handleaccept]
  );

  const SUPPORTED_FORMATS = [ "image/*" ];
  // validation
  const validation = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      code_promo:
        ( codePromoSelected && codePromoSelected.code_promo ) ||
        codePromoGenerate ||
        "",
      type_reduction:
        ( codePromoSelected && codePromoSelected.type_reduction ) || "",
      pourcentage: ( codePromoSelected && codePromoSelected.pourcentage ) || "",
      delais: ( codePromoSelected && codePromoSelected.delais ) || "",
      nbr_max: ( codePromoSelected && codePromoSelected.nbr_max ) || "",
    },
    validationSchema: Yup.object( {
      code_promo: Yup.string().required(
        props.t( "Veuillez renseigner le code promo" )
      ),
      type_reduction: Yup.string().required(
        props.t( "Veuillez renseigner le type de reduction" )
      ),
      pourcentage: Yup.number()
        .min( 0, "Le pourcentage ne peut pas être inférieur à 0" )
        .max( 100, "Le pourcentage ne peut pas être supérieur à 100" )
        .required( props.t( "Veuillez renseigner le pourcentage" ) ),
      delais: Yup.number()
        .min( 0, "Le pourcentage ne peut pas être inférieur à 0" )
        .required( props.t( "Veuillez renseigner le delais" ) ),
      nbr_max: Yup.string().required(
        props.t( "Veuillez renseigner le nombre d'utilisation maximum" )
      ),
    } ),
    onSubmit: ( values ) =>
    {
      // console.log("Edit: ", isEdit);

      const instanceCodePromo = {
        code_promo: values.code_promo,
        type_reduction: values.type_reduction,
        pourcentage: values.pourcentage,
        delais: values.delais,
        nbr_max: values.nbr_max,
      };

      // console.log("instanceCodePromo: ", instanceCodePromo);

      if ( isEdit )
      {
        try
        {
          const data = axiosInstance
            .put(
              `/updatecodepromo/?id=${ codePromoSelected.id }`,
              instanceCodePromo
            )
            .then( ( response ) =>
            {
              // dispatch(onUpdateCodePromo(updateCodePromo));
              validation.resetForm();
              toast.success( props.t( "Code Promo modifié avec succès" ), {
                autoClose: 3000,
              } );
              rafraichirListe();
              // dispatch( onGetCodePromos() );
              handleClick();
            } )
            .catch( ( error ) =>
            {
              toast.error( props.t( "Echec de la modification du Code Promo" ), {
                autoClose: 3000,
              } );
            } );

          // window.location.reload(true);
        } catch ( err )
        {
          console.error( err );
          toast.error( props.t( "Echec de la modification du Code Promo" ), {
            autoClose: 2000,
          } );
        }
        rafraichirListe();
        // dispatch( onGetCodePromos() );
        setIsEdit( false );
      } else
      {
        // console.log("Ajout de code Promo: ", instanceCodePromo);

        try
        {
          const data = axiosInstance
            .post( `/createcodepromo/`, instanceCodePromo )
            .then( ( response ) =>
            {
              // console.log("Reponse sauvegarder avec success: ", response);

              // history.push("/codePromo");
              validation.resetForm();
              toast.success( props.t( "Code Promo ajouté avec succès" ), {
                autoClose: 3000,
              } );
              rafraichirListe();
              // dispatch( onGetCodePromos() );
              handleClick();
            } );
        } catch ( err )
        {
          console.error( err );
          toast.error( props.t( "Echec de l'ajout de la Code Promo" ), {
            autoClose: 3000,
          } );
        }
        rafraichirListe();
        // dispatch( onGetCodePromos() );
      }
      setModal( false );
      setCodePromoSelected( null );
      // toggle();
    },
  } );


  const [ codePromoTable, setCodePromoTable ] = useState( [] )
  useEffect( () =>
  {
    let event =
      roleSession !== "ORGANISATEUR" ?
        codePromos :
        codePromos.filter( item => item.organisation_id === idConnected );

    console.log( 'codePromos: ', codePromos );
    console.log( 'event table: ', event );
    setCodePromoTable( event );
  }, [ roleSession, codePromos, idConnected ] );

  // SideBar CodePromo Deatail

  document.title = props.t( roleSession === "ORGANISATEUR" ? "Code de réduction | Takci" : "Code Promos | Takci" );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( roleSession === "ORGANISATEUR" ? "Code de réduction" : "Code Promos" ) } pageTitle="Takci" />

          <Row>
            <Col lg={ 12 }>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      <button
                        className="btn add-btn"
                        style={ { background: "#002437", color: "white" } }
                        onClick={ () =>
                        {
                          if ( roleSession !== "ORGANISATEUR" )
                          {
                            setModal( true );
                            generatePromoCode();
                          } else
                          {
                            console.log( "Ajouter code de reduction" )
                          }
                        } }
                      >
                        <i className="ri-user-add-line me-1 align-bottom"></i>
                        { props.t( roleSession === "ORGANISATEUR" ? "Ajouter code de reduction" : "Ajouter code promo" ) }
                      </button>{ " " }
                      { codePromoTable.length > 0 && (
                        <button
                          disabled={
                            codePromoTable.length < 0
                          }
                          type="button"
                          className="btn"
                          style={ { color: "#eac22f" } }
                          onClick={ () => setIsExportCSV( true ) }
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{ " " }
                          { props.t( "Export" ) }
                        </button>
                      ) }
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={ 12 }>
              <Card id="codePromoList">
                <CardBody className="pt-0">
                  <div>
                    { !loading ? (
                      codePromoTable.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={ isExportCSV }
                            onCloseClick={ () => setIsExportCSV( false ) }
                            data={
                              codePromoTable.length > 0
                                ? codePromoTable
                                : []
                            }
                          />

                          <TableContainer
                            columns={ columns }
                            data={
                              codePromoTable
                            }
                            isGlobalFilter={ true }
                            isAddUserList={ false }
                            customPageSize={ 8 }
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                          // handleCodePromoClick={ handleCodePromoClicks }
                          />
                        </>
                      ) : (
                        <h2 className="text-center my-3">
                          Aucun { roleSession === "ORGANISATEUR" ? "code de reduction" : "code promo" } disponible
                        </h2>
                      )
                    ) : (
                      <div className="text-center my-3">
                        <Loader style={ { color: "#014c94" } } />
                        <h2>Chargement...</h2>
                      </div>
                    ) }
                  </div>

                  <Modal
                    id="showModal"
                    style={ { maxWidth: 800 } }
                    isOpen={ modal }
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {/* { isEdit === true ? props.t( "Modifier CodePromo" ) : props.t( "Ajouter Code Promo" ) } */ }
                      { isEdit
                        ? props.t( "Modifier Code Promo" )
                        : props.t( "Ajouter Code Promo" ) }
                    </ModalHeader>

                    <Form
                      onSubmit={ ( e ) =>
                      {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      } }
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={ 4 }>
                            <div>
                              <Label
                                htmlFor="code_promo"
                                className="form-label"
                              >
                                { props.t( "Nom du code" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="code_promo"
                                id="code_promo"
                                className="form-control"
                                placeholder={ props.t( "Entrez le nom" ) }
                                type="text"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validation.handleChange }
                                onBlur={ validation.handleBlur }
                                value={ validation.values.code_promo || "" }
                                invalid={
                                  validation.touched.code_promo &&
                                    validation.errors.code_promo
                                    ? true
                                    : false
                                }
                              />
                              { validation.touched.code_promo &&
                                validation.errors.code_promo ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.code_promo }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label
                                htmlFor="type_reduction"
                                className="form-label"
                              >
                                { props.t( "Type de réduction" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="type_reduction"
                                id="type_reduction"
                                className="form-control"
                                type="select"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validation.handleChange }
                                onBlur={ validation.handleBlur }
                                value={ validation.values.type_reduction || "" }
                                invalid={
                                  validation.touched.type_reduction &&
                                    validation.errors.type_reduction
                                    ? true
                                    : false
                                }
                              >
                                <option value="" disabled>
                                  Selectionner le type de réduction
                                </option>
                                <option value="Tous">Tous</option>
                                <option value="Course">Courses</option>
                                <option value="Livraison">Livraisons</option>
                                <option value="Evenement">Evenements</option>
                              </Input>

                              { validation.touched.type_reduction &&
                                validation.errors.type_reduction ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.type_reduction }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label
                                htmlFor="pourcentage"
                                className="form-label"
                              >
                                { props.t( "Pourcentage de reduction" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="pourcentage"
                                id="pourcentage"
                                className="form-control"
                                placeholder={ props.t(
                                  "Entrez le pourcentage de reduction"
                                ) }
                                type="number"
                                max={ 100 }
                                min={ 0 }
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validation.handleChange }
                                onBlur={ validation.handleBlur }
                                value={ validation.values.pourcentage || "" }
                                invalid={
                                  validation.touched.pourcentage &&
                                    validation.errors.pourcentage
                                    ? true
                                    : false
                                }
                              />
                              { validation.touched.pourcentage &&
                                validation.errors.pourcentage ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.pourcentage }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label htmlFor="delais" className="form-label">
                                { props.t( "Délai de Validité" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <InputGroup>
                                <Input
                                  name="delais"
                                  id="delais"
                                  className="form-control"
                                  placeholder={ props.t( "Entrez le delai" ) }
                                  type="number"
                                  min={ 0 }
                                  validate={ {
                                    required: { value: true },
                                  } }
                                  onChange={ validation.handleChange }
                                  onBlur={ validation.handleBlur }
                                  value={ validation.values.delais }
                                  invalid={
                                    validation.touched.delais &&
                                      validation.errors.delais
                                      ? true
                                      : false
                                  }
                                />

                                <InputGroupText>jour(s)</InputGroupText>
                              </InputGroup>
                              { validation.touched.delais &&
                                validation.errors.delais ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.delais }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div>
                              <Label htmlFor="nbr_max" className="form-label">
                                { props.t( "Maximum d'utilisation" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="nbr_max"
                                id="nbr_max"
                                className="form-control"
                                placeholder={ props.t(
                                  "Entrez le maximum d'utilisation"
                                ) }
                                type="number"
                                min={ 0 }
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validation.handleChange }
                                onBlur={ validation.handleBlur }
                                value={ validation.values.nbr_max }
                                invalid={
                                  validation.touched.nbr_max &&
                                    validation.errors.nbr_max
                                    ? true
                                    : false
                                }
                              />
                              { validation.touched.nbr_max &&
                                validation.errors.nbr_max ? (
                                <FormFeedback type="invalid">
                                  { validation.errors.nbr_max }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={ () =>
                            {
                              setModal( false );
                              rafraichirListe();
                              // dispatch( onGetCodePromos() );
                              generatePromoCode();
                            } }
                            className="btn-light"
                          >
                            { props.t( "Fermer" ) }
                          </Button>

                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetCodePromos); }} > {props.t("Fermer")} </button> */ }
                          <Button
                            type="submit"
                            className="btn"
                            style={ { background: "#002437", color: "white" } }
                            id="add-btn"
                          >
                            { isEdit
                              ? props.t( "Edit" )
                              : props.t( "Ajouter Code Promo" ) }
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal
                    id="showModalConfirmDelete"
                    style={ { maxWidth: 800 } }
                    isOpen={ modalConfirmDelete }
                    centered
                  >
                    <ModalBody className="py-3 px-5">
                      <div className="mt-2 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/gsqxdxog.json"
                          trigger="loop"
                          colors="primary:#014c94,secondary:#eac22f"
                          style={ { width: "100px", height: "100px" } }
                        ></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Êtes-vous sûr ?</h4>
                          <p className="text-muted mx-4 mb-0">
                            Êtes-vous sûr de vouloir supprimer ce code promo ?
                          </p>
                        </div>
                      </div>
                      <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <button
                          type="button"
                          className="btn w-sm btn-light"
                          data-bs-dismiss="modal"
                          onClick={ () =>
                          {
                            setModalConfirmDelete( false );
                          } }
                        >
                          Fermer
                        </button>
                        <button
                          type="button"
                          className="btn w-sm btn-danger"
                          id="delete-organizer"
                          onClick={ handleDelete }
                        >
                          Oui, supprimez-le !
                        </button>
                      </div>
                    </ModalBody>
                  </Modal>

                  <ToastContainer closeButton={ false } />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

CodePromo.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( CodePromo ) );
